import * as api from '../api/plants';

// Actions Creators
export const getPlants = () => async (dispatch) => {
    try {
        const { data } = await api.fetchPlants();
        
        dispatch({ type: 'FETCH_ALL_PLANT', payload: data });
        
    } catch (error) {
        console.log(error)
    }
}
    
export const createPlants = (plant) => async (dispatch) => {

    try {
        const { data } = await api.createPlants(plant);

        dispatch({ type: 'CREATE_PLANT', payload: data });

    } catch (error) {
        console.log(error)
    }
}

export const updatePlant = (id, plant) => async (dispatch) => {
    try {
        const { data } = await api.updatePlant(id, plant);

        dispatch({ type: 'UPDATE_PLANT', payload: data });

    } catch (error) {
        console.log(error)
    }
}

export const deletePlant = (id) => async (dispatch) => {
    try {
        await api.deletePlant(id);

        dispatch({ type: 'DELETE_PLANT', payload: id });

    } catch (error) {
        console.log(error)
    }
}
